import React from 'react';
import T from 'prop-types';
import { Loader } from 'web-components';

import LoadingStatusComponent from '../components/StatusIndicator/LoadingStatusComponent';

const DefaultLoadingComponent = () => <Loader standalone size={20} />;

/**
 * @param {React.ComponentType<any>} Component
 * @returns {React.FC<any>}
 */
const withLoadingState = Component => {
  /** @type {React.FC<any>} */
  const C = ({
    loadingState,
    loadingComponent = DefaultLoadingComponent,
    errorComponent = null,
    reloadAction = null,
    ignoreError = false,
    ...props
  }) => (
    <LoadingStatusComponent
      loadingState={loadingState}
      loadingComponent={loadingComponent}
      errorComponent={errorComponent}
      ignoreError={ignoreError}
      reloadAction={reloadAction}
      renderComponent={Component}
      renderProps={props}
    />
  );

  C.displayName = `withLoadingState(${Component.displayName || Component.name})`;
  C.WrappedComponent = Component;
  C.propTypes = {
    loadingState: T.shape({}).isRequired,
    loadingComponent: T.oneOfType([T.node, T.string, T.func]),
    errorComponent: T.oneOfType([T.node, T.string, T.func]),
    ignoreError: T.bool,
    reloadAction: T.func
  };

  return C;
};

export default withLoadingState;
